module.exports = __webpack_public_path__ + "images/lpage-xp-levels-2.png";